// const baseURL =  "http://127.0.0.1:8000/paras/"
const baseURL =  "https://sr.yashvitech.com/paras/"
const config = {
    apiBaseURL : `${baseURL}`,
    staticBaseURL : `${baseURL}`,
    apiTimeout: 500000
}
export default config;

